/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HistoryDto } from '../../models/history-dto';
import { UpdateHistoryDto } from '../../models/update-history-dto';

export interface HistoryControllerUpdateV1$Params {
  id: string;
      body: UpdateHistoryDto
}

export function historyControllerUpdateV1(http: HttpClient, rootUrl: string, params: HistoryControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HistoryDto>> {
  const rb = new RequestBuilder(rootUrl, historyControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HistoryDto>;
    })
  );
}

historyControllerUpdateV1.PATH = '/api/v1/history/{id}';
